import request from '@/utils/request'

const userBaseUrl = 'api/googleuser/'

export function login(data) {
    return request({
        url: userBaseUrl + 'login?brand=GLOWRIUM&grant_type=1',
        method: 'post',
        data: data
    })
}

export function linkCode(data) {
    return request({
        url: userBaseUrl + 'link_code',
        method: 'post',
        data: data
    })
}

